export default ({ COLORS }) => ({
  archive: {
    color: COLORS.RED.NORMAL
  }
})
